import { cn } from '@/utils';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import Button from '../common/button';
import {
	ButtonSelectApplicantProps,
	IProps as ISelectApplicantProps,
} from './select-applicant-modal.type';
import SelectApplicantByFranchise from './select-applicant-modal.view';

const SelectApplicantButton = (props: ButtonSelectApplicantProps) => {
	const { className, ...restProps } = props;

	const [open, setOpen] = useState(false);

	const selectApplicantModal =
		useRef<FunctionComponent<ISelectApplicantProps>>();

	const onOpenModal = useCallback(() => {
		if (!selectApplicantModal.current) {
			selectApplicantModal.current = SelectApplicantByFranchise;
		}

		setOpen(true);
	}, []);

	const onCloseModal = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Button
				secondary
				className={cn('min-w-0', className)}
				onClick={onOpenModal}
			>
				추가
			</Button>
			{selectApplicantModal.current && (
				<selectApplicantModal.current
					{...{ ...restProps, open, onCloseModal }}
				/>
			)}
		</>
	);
};

export default memo(SelectApplicantButton);
